<template>
  <b-card class="mb-3">
    <div class="row">
      <div class="col-md-12">
        <h4 class="card-title float-left">Filtry</h4>
        <button class="btn btn-outline-primary float-right collapse-button" v-b-toggle.collapse-body>{{ collapseBody ? 'Zwiń' : 'Rozwiń' }}</button>
      </div>
    </div>

    <b-collapse id="collapse-body" v-model="collapseBody">
      <b-card-body>
        <div class="row">
          <div class="col-md-6">
            <app-advanced-select :model="$schema.userId" :values="users"></app-advanced-select>
          </div>

          <div class="col-md-6">
            <app-tree-structure-picker :model="$schema.logicalStructureId"></app-tree-structure-picker>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-6">
            <app-datepicker class="dateInput" :model="$schema.date.start"></app-datepicker>
          </div>

          <div class="col-md-6">
            <app-datepicker class="dateInput" :model="$schema.date.end"></app-datepicker>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-12">
            <app-input :model="$schema.search"></app-input>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-12">
            <app-advanced-select :model="$schema.tags" :values="tags" :multiple="true"></app-advanced-select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12 text-right">
            <button class="btn btn-outline-primary" @click="applyFilters">Filtruj</button>
          </div>
        </div>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import schema from '@/schemas/filters.schema';
import formMixin from '@/mixins/formMixin';
import filtersService from '@/services/filters.service';

export default {
  mixins: [formMixin],
  schema,
  props: {
    users: Array,
    tags: Array
  },
  data() {
    return {
      collapseBody: false
    };
  },
  methods: {
    loadFilterOptions() {
      this.$schema.$setData(filtersService.queryToFilters(this.$route.query));
    },
    applyFilters() {
      if (this.$schema.$validateAll().length > 0) {
        return;
      }
      this.$emit('apply', this.$schema.$model);
    }
  },
  beforeMount() {
    this.loadFilterOptions();
  }
};
</script>

<style scoped>
.collapse-button {
  width: 100px;
}
</style>
